import { createSelector } from 'reselect';

const scheduleModuleSelector = ({ scheduleModule = {} }) => scheduleModule;

export default createSelector(
    scheduleModuleSelector,
    ({ buckets = [] }) => buckets
);

export const scheduleModuleNameSelector = createSelector(
    scheduleModuleSelector,
    ({ name = 'scheduleModule' }) => name
);



// WEBPACK FOOTER //
// ./app/common/selectors/scheduleModuleBucketsSelector.js